import styled from 'styled-components'

export const Container = styled.div`
  img {
    height: auto;
    width: calc(100vw - 480px);
    max-width: 1440px;
  }
`
